// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import type { FluidDragActions } from 'react-beautiful-dnd';

type Position = {
	x: number;
	y: number;
};

// easing function for animation
const easeInOutSine = (time: number, start: number, end: number, count: number) => {
	const diff = end - start;
	return (-diff / 2) * (Math.cos((Math.PI * time) / count) - 1) + start;
};

// returns a collection of coordinates
export const getAnimationPoints = ({
	start,
	end,
	count,
}: {
	start: Position;
	end: Position;
	count: number;
}): Position[] => {
	const points: Array<Position> = [];

	for (let i = 0; i < count; i += 1) {
		points.push({
			x: easeInOutSine(i, start.x, end.x, count),
			y: easeInOutSine(i, start.y, end.y, count),
		});
	}

	return points;
};

// animate card in requestAnimationFrame loop one coordinate at a time, then drop it
export const animateCard = (drag: FluidDragActions, points: Position[]) => {
	requestAnimationFrame(() => {
		const nextPosition = points.shift();
		nextPosition && drag.move(nextPosition);

		if (points.length) {
			animateCard(drag, points);
		} else {
			drag.drop();
		}
	});
};
